import { Box, ButtonBase, Tooltip } from "@mui/material";
import React from "react";
import Iconify from "../../components/iconify/Iconify";
import OrderMoreOptionsMenu from "./OrderMoreOptionsMenu";

function OrderActionsCounter({
  activeOrderId,
  onCounterSettle,
  anchorEl,
  open,
  onOpenMenu,
  onCloseMenu,
  isLoading,
  onActivityClick,
}) {
  return (
    <Box
      className="order-actions-bar"
      style={{
        width: "auto",
      }}
    >
      <ButtonBase
        className="order-btn settle"
        sx={{
          maxWidth: "100px",
          //   opacity: !activeOrderId ? 0.4 : 1,
          //   cursor: !activeOrderId ? "not-allowed" : "pointer",
          //   pointerEvents: !activeOrderId ? "none" : "auto",
        }}
        onClick={onCounterSettle}
        // disabled={!activeOrderId}
        disabled={isLoading}
      >
        Print & Settle
      </ButtonBase>
      <Tooltip title="More options">
        <ButtonBase className="order-btn more" onClick={onOpenMenu}>
          <Iconify icon="mdi:dots-vertical" />
        </ButtonBase>
      </Tooltip>

      {/* More Menu */}
      <OrderMoreOptionsMenu
        anchorEl={anchorEl}
        open={open}
        onClose={onCloseMenu}
        activeOrderId={activeOrderId}
        onActivityClick={onActivityClick}
      />
    </Box>
  );
}

export default OrderActionsCounter;
